
import Skeleton from '@/components/skeleton/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { SecurityService } from '@/services'
import { conclusionMap } from '@/views/security/badInfoDetail.vue'

@Component({
    name: 'bad-info',
    components: {
        Skeleton,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private tableData = []
    private dealStatus = 1
    private isLoading = true
    private statusOptions = [
        { key: 1, value: '未处理' }, 
        { key: 2, value: '已处理' }
    ]

    private async mounted() {
        this.isLoading = true
        await this.getViolatingList()
        this.isLoading = false
    }

    // 获取数据列表
    private async getViolatingList() {
        const params = {
            page_index: this.pageIndex,
            page_size: this.pageSize,
            status: this.dealStatus
        }
        const result = await SecurityService.getViolatingList(params)
        if (result.status === 200) {
            this.tableData = result.data.list
            this.pageTotal = result.data.page_total
        }
    }

    private matchConclusion(key: number) {
        const item = Object.values(conclusionMap).find(n => n.key === key)
        return item ? item.name : '暂无结论'
    }

    private async updateInfo(params: any) {
        const result = await SecurityService.updateViolatingInfo(params)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '设置成功' })
            return { status: true }
        } else {
            this.$message({ type: 'error', message: result.message })
            return { status: false }
        }
    }

    private onDealStatusChange(status: number) {
        this.dealStatus = status
        this.getViolatingList()
    }

    private async onStatusSelect(status: any, item: any) {
        const { id } = item
        const params = { id, status }
        const result = await this.updateInfo(params)
        if (result.status) {
            item.status = status
        }
    }

    private async onGoDetail(row: any) {
        window.open('/security/bad-info/' + row.id, '_blank')
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getViolatingList)
    }
}
